import React from 'react';

const useFormatUrlsInText = (): ((text: string | undefined) => (string | JSX.Element)[]) => {
  const formatUrlInText = (text: string | undefined): (string | JSX.Element)[] => {
    if (!text) return [''];
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const data: (string | JSX.Element)[] = text.split(urlRegex).map((part) => {
      if (part.match(urlRegex)) {
        return <a href={part}>{part}</a>;
      }
      return part;
    });

    return data;
  };

  return formatUrlInText;
};

export default useFormatUrlsInText;
